import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { SessionService } from '../../../services/session.service';
import { TranslocoDirective } from '@jsverse/transloco';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';

export interface FeatureInDevelopmentDialogData {
	targetRoute?: string;
	continue?: boolean;
}

@Component({
	selector: 'ara-feature-in-development-dialog',
	imports: [MatDialogContent, MatIconModule, MatButtonModule, TranslocoDirective, CdkDrag, CdkDragHandle, MatDialogTitle],
	templateUrl: './ara-feature-in-development-dialog.component.html',
	styleUrl: './ara-feature-in-development-dialog.component.scss',
	changeDetection: ChangeDetectionStrategy.Eager,
	host: { class: 'block relative' },
})
export class AraFeatureInDevelopmentDialogComponent {
	private readonly dialogRef = inject(MatDialogRef<AraFeatureInDevelopmentDialogComponent>);
	private readonly router = inject(Router);
	private readonly sessionService = inject(SessionService);
	private readonly data: FeatureInDevelopmentDialogData = inject(MAT_DIALOG_DATA, { optional: true }) ?? {};

	readonly isDevRole = this.sessionService.isDevRole();

	continueAsDev(): void {
		this.dialogRef.close(this.data.continue);
		if (this.data.targetRoute) {
			this.router.navigate([this.data.targetRoute]);
		}
	}

	protected close(): void {
		this.dialogRef.close(this.data.continue && this.isDevRole);
	}
}
